module.exports = __webpack_public_path__ + "img/logo-whiteloader.71e192d8.svg";